import type {UntypedPayload} from 'constants/events/EventPayloadUtils';

export const AA_SEQUENCE_EVENT_PAYLOADS = {
  AA_SEQUENCE_AA_UPDATE_COMPLETED: {} as UntypedPayload,
  AA_SEQUENCE_ADD_FOR_SEARCH: {} as UntypedPayload,
  AA_SEQUENCE_CLEAR_SEARCH_RESULTS: {} as UntypedPayload,
  AA_SEQUENCE_DELETE_COMPLETED: {} as UntypedPayload,
  AA_SEQUENCE_FETCH_VERSIONS: {} as UntypedPayload,
  AA_SEQUENCE_FETCH_VERSIONS_COMPLETED: {} as UntypedPayload,
  AA_SEQUENCE_FETCH_VERSIONS_FAILED: {} as UntypedPayload,
  AA_SEQUENCE_MERGE: {} as UntypedPayload,
  PROTEIN_OPEN_COMPLETED: {} as UntypedPayload,
  AA_SEQUENCE_REMOVE_FROM_SEARCH: {} as UntypedPayload,
  AA_SEQUENCE_SEARCH_AMINO_ACIDS: {} as UntypedPayload,
  AA_SEQUENCE_SEARCH_OPEN_VIEW: {} as UntypedPayload,
  AA_SEQUENCE_SEARCH_OPEN_VIEW_COMPLETED: {} as UntypedPayload,
  AA_SEQUENCE_UPDATE_COMPLETED: {} as UntypedPayload,
  AA_SEQUENCE_VIEW_NEXT_SEARCH_RESULT: {} as UntypedPayload,
  AA_SEQUENCE_VIEW_PREVIOUS_SEARCH_RESULT: {} as UntypedPayload,
  AA_SEQUENCE_SELECT_SEARCH_RESULT: {} as UntypedPayload,
  AA_SEQUENCE_SET_CURRENT_COORDINATE_STRUCTURE_ID: {} as {
    actionType: 'AA_SEQUENCE_SET_CURRENT_COORDINATE_STRUCTURE_ID';
    versionId: number;
    coordinateStructureId: string | null;
  },

  PROTEIN_ALIGNMENT_DELETE_COMPLETED: {} as UntypedPayload,
  PROTEIN_ALIGNMENT_OPEN_COMPLETED: {} as UntypedPayload,
  PROTEIN_ALIGNMENT_RENAME_COMPLETED: {} as UntypedPayload,
} as const;

export type AaSequenceEventPayload = typeof AA_SEQUENCE_EVENT_PAYLOADS;
